var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.15625 2.30769C0.15625 1.69565 0.404591 1.10868 0.846641 0.675907C1.28869 0.243131 1.88824 0 2.51339 0H19.7991C20.4243 0 21.0238 0.243131 21.4659 0.675907C21.9079 1.10868 22.1562 1.69565 22.1562 2.30769V14.6154C22.1562 15.2274 21.9079 15.8144 21.4659 16.2472C21.0238 16.6799 20.4243 16.9231 19.7991 16.9231H2.51339C1.88824 16.9231 1.28869 16.6799 0.846641 16.2472C0.404591 15.8144 0.15625 15.2274 0.15625 14.6154L0.15625 2.30769ZM2.51339 1.53846C2.30501 1.53846 2.10516 1.61951 1.95781 1.76376C1.81046 1.90802 1.72768 2.10368 1.72768 2.30769V14.6154C1.72768 14.8194 1.81046 15.0151 1.95781 15.1593C2.10516 15.3036 2.30501 15.3846 2.51339 15.3846H19.7991C20.0075 15.3846 20.2073 15.3036 20.3547 15.1593C20.502 15.0151 20.5848 14.8194 20.5848 14.6154V2.30769C20.5848 2.10368 20.502 1.90802 20.3547 1.76376C20.2073 1.61951 20.0075 1.53846 19.7991 1.53846H2.51339ZM15.0848 20H7.22768V18.4615H15.0848V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktop);
export default __webpack_public_path__ + "static/media/icon-desktop.73b935b49cd73d2eb8a3b54f8ff5233a.svg";
export { ForwardRef as ReactComponent };